const getFromMap = (tagMap, key) => {
  if (!tagMap || key == null || !(key in tagMap)) return null;
  const raw = tagMap[key];
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    return trimmed.length ? trimmed : null;
  }
  return raw ?? null;
};

const resolveTagName = (tagMap, tag) => {
  if (!tagMap) return null;

  const direct = getFromMap(tagMap, tag);
  if (direct) return direct;

  const numericTag = Number(tag);
  if (!Number.isNaN(numericTag)) {
    const numeric = getFromMap(tagMap, numericTag);
    if (numeric) return numeric;
  }

  if (typeof tag === 'number') {
    const asString = getFromMap(tagMap, String(tag));
    if (asString) return asString;
  }

  return null;
};

const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const escapeAttr = (value) =>
  escapeHtml(value).replace(/"/g, '&quot;');

const buildTagHtml = (tag, isOpen, tagMap) => {
  const rawTag = String(tag);
  const tagName = resolveTagName(tagMap, rawTag);
  const typeAttr = isOpen ? 'open' : 'close';
  const typeLabel = isOpen ? 'opening' : 'closing';
  const capitalizedTypeLabel = typeLabel.charAt(0).toUpperCase() + typeLabel.slice(1);
  const trimmedName = typeof tagName === 'string' ? tagName.trim() : '';
  const encodedTag = escapeAttr(rawTag);
  const displayTag = escapeHtml(rawTag);

  const nameAttr = trimmedName
    ? ` data-tag-name="${escapeAttr(trimmedName)}"`
    : '';

  const titleText = trimmedName
    ? `${trimmedName} (${typeLabel} ${rawTag})`
    : `${capitalizedTypeLabel} tag ${rawTag}`;
  const labelText = trimmedName
    ? `${trimmedName} ${typeLabel} tag ${rawTag}`
    : `${typeLabel} tag ${rawTag}`;

  return (
    `<span class="inline-tag" data-tag="${encodedTag}" data-type="${typeAttr}"${nameAttr} title="${escapeAttr(titleText)}" aria-label="${escapeAttr(labelText)}" draggable="true">` +
    `<span class="tag-pill" aria-hidden="true">${displayTag}</span>` +
    `</span>`
  );
};

export { resolveTagName, buildTagHtml };
